<template>
    <div v-show="CartHasItems" class="checkout-discover-cart">
        <div id="body" v-show="CartHasItems">
            <CartTableDiscoverMode :edit-mode="true" :summary-mode="false"></CartTableDiscoverMode>
        </div>
        <div id="footer">
            <div id="totals" v-show="CartHasItems">
                <CartTotalsDiscoverMode :edit-mode="true" :summary-mode="false"></CartTotalsDiscoverMode>
            </div>
        </div>
    </div>
</template>

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTableDiscoverMode from '@/components/CartTable-DiscoverMode.vue';
    import CartTotalsDiscoverMode from '@/components/CartTotals-DiscoverMode.vue';

    export default {
        name: 'CheckoutCartDiscoverMode',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTableDiscoverMode,
            CartTotalsDiscoverMode
        },
        beforeMount() {
            // Always load expanded cart for checkout sidebar; Angular updateCart also syncs back via syncVueCheckoutCartFromAngular.
            this.getCartSummary(true, this.syncAngularCheckoutCart);
        }
    }
</script>
